import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  GET_STATEMENT,
  GET_STATEMENT_DETAIL,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'statement' })
export default class Statement extends VuexModule {
  dataStatement: any = [];

  dataStatementDetail: any = [];

  @Mutation
  mutateStatement(statement) {
    this.dataStatement = statement;
  }

  @Action({ commit: 'mutateStatement' })
  FetchStatement(params) {
    return Vue.axios({
      url: BASE_URL + GET_STATEMENT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const statement = data.data;
          return statement;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateStatementDetail(statement) {
    this.dataStatementDetail = statement;
  }

  @Action({ commit: 'mutateStatementDetail' })
  FetchStatementDetail(params) {
    return Vue.axios({
      url: BASE_URL + GET_STATEMENT_DETAIL,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const statement = data.data;
          return statement;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
